import { render, staticRenderFns } from "./CopyCollectionToDocuments.vue?vue&type=template&id=7ba15e14&scoped=true"
import script from "./CopyCollectionToDocuments.vue?vue&type=script&lang=js"
export * from "./CopyCollectionToDocuments.vue?vue&type=script&lang=js"
import style0 from "./CopyCollectionToDocuments.vue?vue&type=style&index=0&id=7ba15e14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba15e14",
  null
  
)

export default component.exports